import {Actions, closeDialog, openDialog} from 'platform/components';
import {useDateTimeFormatter} from 'platform/locale';

import {ReportDocumentDialog} from '@dms/features/report-document';
import i18n from '@dms/i18n';

import type {StockTakeReport} from '../types/StockTakeReport';
import {createStockTakeReportDocument} from '../utils/createStockTakeReportDocument';

export function StockTakeReportButton(props: {report: StockTakeReport}) {
  const formatDateTime = useDateTimeFormatter();
  const title = i18n.t('module.reportDocument.actions.generateDocument');

  const handleGenerate = () => {
    const report = props.report;
    const dialogId = `stock-take-report-${report.filename}`;
    const generatedAt = formatDateTime('dateTimeMedium', new Date());
    const locale = i18n.language;

    openDialog(
      <ReportDocumentDialog
        isContentFixed
        reportName={report.title}
        sectionOptions={report.sections.map((section) => ({
          id: section.id,
          title: section.title,
          description: section.groups.map((group) => group.title).join(' · '),
        }))}
        selectionDescription={report.metadata
          .slice(0, 3)
          .map((metric) => `${metric.label}: ${metric.value}`)
          .join(' · ')}
        createDocument={() => ({
          filename: report.filename,
          html: createStockTakeReportDocument({
            report,
            generatedAt,
            generatedLabel: i18n.t('general.labels.generated'),
            locale,
          }),
        })}
        onClose={() => closeDialog(dialogId)}
      />,
      {
        id: dialogId,
        title,
        scrollBehavior: 'outside',
      }
    );
  };

  return (
    <Actions
      actions={[
        {
          type: 'button',
          title,
          'aria-label': title,
          leftIcon: 'action/description',
          onClick: handleGenerate,
        },
      ]}
    />
  );
}
